module.exports = __webpack_public_path__ + "img/image-style-02.27eb9ea5.svg";